module.exports = __webpack_public_path__ + "static/media/octorion-race.0822c528.svg";